import { useNavigate, useSearch } from "@tanstack/react-router";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { useModerationHistoryQuery } from "../api/queries";
import type { HistorySearchParams } from "../ui/ModerationHistoryFilter";
import { ModerationHistoryFilter } from "../ui/ModerationHistoryFilter";
import { ModerationHistoryTable } from "../ui/ModerationHistoryTable";
import { ModerationHistoryToolbar } from "../ui/ModerationHistoryToolbar";

export function ModerationHistoryPage() {
  const nav = useNavigate({ from: "/app/moderation/history" });
  const search = useSearch({
    from: "/app/moderation/history",
  }) as HistorySearchParams;

  const limit = search.limit ?? 50;
  const offset = search.offset ?? 0;

  const list = useModerationHistoryQuery({
    limit,
    offset,
    fromDate: search.fromDate,
    toDate: search.toDate,
    targetType: search.targetType,
  });

  const data = list.data?.data ?? [];
  const meta = list.data?.meta ?? { total: 0, limit: 50, offset: 0 };

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "ການກວດກາຕະຫຼາດ", to: "/app/moderation" },
            { label: "ປະຫວັດການກວດກາ" },
          ]}
        />
      </Header>

      <Main>
        <ModerationHistoryToolbar />

        <div className="flex flex-col rounded-xl border bg-card pt-2">
          <ModerationHistoryFilter />

          <ModerationHistoryTable
            isLoading={list.isLoading}
            data={data}
            offset={meta.offset}
            limit={meta.limit}
            totalCount={meta.total}
            onPaginationChange={(newOffset, newLimit) =>
              nav({ search: { ...search, offset: newOffset, limit: newLimit } })
            }
          />
        </div>
      </Main>
    </>
  );
}
